import { AfterContentInit, Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';
import { SatisfacaoService } from 'src/app/services/satisfacao-service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { Util } from 'src/app/utils/util.util';
import { IMAGENS_SATISFACAO, VALORES_SATISFACAO } from "./../../shareds/constantes"

@Component({
  selector: 'app-satisfacao-servico',
  templateUrl: './satisfacao-servico.component.html',
  styleUrls: ['./satisfacao-servico.component.scss']
})
export class SatisfacaoServicoComponent implements OnInit, AfterContentInit {

  constructor(
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private satisfacaoService: SatisfacaoService
  ) { }

  public inputDataInicial: HTMLInputElement
  public inputDataFinal: HTMLInputElement
  public maskData = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
  public imagens_satisfacao = IMAGENS_SATISFACAO

  public isProcessing: boolean = false

  public autorizacoes: UsuarioAutorizacoes;
  public subtituloResultadoPesquisa = ''

  public validations = {
    inputDataInicialNotEmpty: true,
    inputDataFinalNotEmpty: true,
    inputDataInicialValid: true,
    inputDataFinalValid: true,
    dataFinalMaiordataInicial: true,

    allFieldsValids() {
      return (
        this.inputDataInicialValid &&
        this.inputDataFinalValid &&
        this.dataFinalMaiordataInicial &&
        this.inputDataInicialNotEmpty &&
        this.inputDataFinalNotEmpty
      )
    },

    resetAllValidations() {
      this.inputDataInicialValid = true
      this.inputDataFinalValid = true
      this.dataFinalMaiordataInicial = true
      this.inputDataInicialNotEmpty = true
      this.inputDataFinalNotEmpty = true
    },
  }

  public results: any;

  tipoGrafico: string = ""; // bar ou pie
  optionsChart: any = undefined;
  graficoSeries: string[] = [];
  graficoCategorias: string[] = VALORES_SATISFACAO;
  graficoColors: string[] = ["#660066", "#036A3A", "#8EC640", "#FAB042", "#E15269", "#BD2130"];

  ngOnInit() {
    this.inputDataInicial = document.querySelector('.inputDataInicial')
    this.inputDataFinal = document.querySelector('.inputDataFinal')
  }

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('satisfacao-servico');
  }

  public submit() {
    if (this.allFieldsValids()) {
      this.isProcessing = true
      this.graficoSeries = [];

      this.satisfacaoService
        .ObterSatisfacaoServicoPorPeriodo(this.getParameters())
        .subscribe(
          (response) => {

            this.subtituloResultadoPesquisa = `Período entre <b>${this.inputDataInicial.value}</b> e <b>${this.inputDataFinal.value}</b>`

            this.results = response

            this.graficoSeries.push(this.results.naoInformado);
            this.graficoSeries.push(this.results.excelente);
            this.graficoSeries.push(this.results.muitoBom);
            this.graficoSeries.push(this.results.bom);
            this.graficoSeries.push(this.results.ruim);
            this.graficoSeries.push(this.results.muitoRuim);

            this.ExibirGrafico("bar");
            this.isProcessing = false
          },
          (error) => {
            this.isProcessing = false
            this.toastr.error(`Erro ao tentar obter os emprestimos`)
            console.log(error)
          },
        )
    }
  }

  public allFieldsValids() {
    this.validations.inputDataInicialNotEmpty =
      this.inputDataInicial.value != ''
    this.validations.inputDataFinalNotEmpty = this.inputDataFinal.value != ''

    return this.validations.allFieldsValids()
  }

  public checkDataValidations() {
    this.resetDataValidations()

    const dataInicial = this.inputDataInicial.value
    const dataFinal = this.inputDataFinal.value

    if (dataInicial != '' && dataFinal != '') {
      this.validations.inputDataInicialValid = Util.validaData(dataInicial)
      this.validations.inputDataFinalValid = Util.validaData(dataFinal)

      if (
        this.validations.inputDataInicialValid &&
        this.validations.inputDataFinalValid
      ) {
        if (
          Date.parse(Util.formatarDataptBRToenUS(dataFinal)) <
          Date.parse(Util.formatarDataptBRToenUS(dataInicial))
        ) {
          this.validations.dataFinalMaiordataInicial = false
        }
      }
    } else {
      this.validations.inputDataInicialNotEmpty = dataInicial != ''
      this.validations.inputDataFinalNotEmpty = dataFinal != ''
    }
  }

  private resetDataValidations() {
    this.validations.inputDataInicialValid = true
    this.validations.inputDataFinalValid = true
    this.validations.dataFinalMaiordataInicial = true
    this.validations.inputDataInicialNotEmpty = true
    this.validations.inputDataFinalNotEmpty = true
  }

  getParameters() {
    return {
      dataInicial: Util.formatarDataptBRToenUS(this.inputDataInicial.value),
      dataFinal: Util.formatarDataptBRToenUS(this.inputDataFinal.value),
    }
  }

  reset() {
    this.validations.resetAllValidations()
    this.results = []
    this.subtituloResultadoPesquisa = ''
  }


  ExibirGrafico(tipo: string) {

    this.tipoGrafico = tipo;

    if (this.tipoGrafico == "bar") {
      this.optionsChart = {
        series: [{ name: "Satisfacao Serviço Realizado", data: this.graficoSeries }],
        chart: { height: "300", type: "bar" },
        xaxis: {
          categories: this.graficoCategorias,
          labels: { show: true },
        },
        yaxis: { min: 0, forceNiceScale: true },
        dataLabels: { style: { fontWeight: 700, colors: ["#000"] }, offsetY: -20 },
        plotOptions: {
          bar: {
            dataLabels: {
              position: "top" // top, center, bottom
            }
          }
        },
      };
    }

    if (this.tipoGrafico == "pie") {
      this.optionsChart = {
        series: this.graficoSeries,
        chart: { height: "300", type: "donut" },
        labels: this.graficoCategorias,
        dataLabels: { enabled: true },
        autoUpdateSeries: true,
        colors: this.graficoColors,
      };
    }
  }
}
